import Vue, { PropType } from 'vue';
export type ResourceOrNull = object | null | undefined | any;
export type ModuleResource = PropType<'event' | 'generic' | 'genericWithName'>;

import { cloneDeep } from 'lodash';
export const EMTPYRESOURCE = Object.freeze({
  owner: '',
  logo: null,
  avatar: null,
  name: '' ?? {
    title: '',
    first: '',
    last: ''
  },
  description: '',
  bio: '',
  dates: [] as any[],
  timezone: '',
  website: '',
  phone: '',
  email: '',
  url: '',
  address: {
    address1: '',
    address2: '',
    locality: '',
    region: '',
    postal_code: '',
    country: {
      code: '',
      name: ''
    }
  },
  social: {
    facebook: '',
    instagram: '',
    linkedin: '',
    twitter: '',
    youtube: ''
  },
  event: localStorage.getItem('current__event')
});
export default Vue.extend({
  name: 'measurable',

  props: {
    module: {
      type: [String] as ModuleResource,
      default: 'generic'
    }
  },

  data: () => ({
    EMTPYRESOURCE,
    resource: cloneDeep(EMTPYRESOURCE) as ResourceOrNull
  }),


});
